export default __webpack_public_path__ + "static/media/movieproject.a8e5807c.png";